import { FC } from "react";

interface PriceProps {
  ListPrice: number;
  blur: boolean;
}

const Price: FC<PriceProps> = ({ ListPrice, blur }) => {
  return (
    <div
      className={`absolute w-full h-full flex flex-col ${blur ? "blur" : ""}`}
    >
      <div className="flex-1 flex items-end">
        <p className="text-white bg-primary text-sm rounded-md text-center px-3 py-1 ml-2 mb-2">
          ${ListPrice.toLocaleString()}
        </p>
      </div>
    </div>
  );
};

export default Price;
